module.exports = __webpack_public_path__ + "static/media/caligraphy_dark.55bea136.png";